module.exports = {"term_agreement_by_ll_owner":"Pom zoo txog Cov Nqi Lus los ntawm tus Tswv Tsev/Tus Tswv ntawm lub chaw"};